import React, { createContext, useContext, useRef, useState } from "react";

import { MFAVerificationDialog } from "@/components/MFAVerificationDialog";

interface ContextType {
  verifyMfa: () => Promise<boolean>;
}

const MfaVerificationContext = createContext<ContextType | null>(null);

export const MfaVerificationProvider = ({ children }: { children: React.ReactNode }) => {
  const ref = useRef<(value: boolean) => void>();
  const [open, setOpen] = useState(false);

  const verifyMfa = (): Promise<boolean> => {
    setOpen(true);
    return new Promise(resolve => {
      ref.current = resolve;
    });
  };

  const handleSuccess = () => {
    setOpen(false);
    ref.current?.(true);
  };

  const handleCancel = () => {
    setOpen(false);
    ref.current?.(false);
  };

  return (
    <MfaVerificationContext.Provider value={{ verifyMfa }}>
      {children}
      <MFAVerificationDialog isOpen={open} onSuccess={handleSuccess} onCancel={handleCancel} />
    </MfaVerificationContext.Provider>
  );
};

export const useMfaVerification = () => {
  const context = useContext(MfaVerificationContext);
  if (!context) {
    throw new Error("useMfaVerification must be used within a MfaVerificationProvider");
  }
  return context;
};
